import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GenericTable from 'componentes/generic/GenericTable.js';
import React from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';

const TiposPlataformaTable = ({
  setIdTipoPlataforma,
  setOpenModal,
  tiposPlataforma
}) => {
  const columns = [
    {
      accessorKey: 'idplataforma',
      header: '#',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'plataforma',
      header: 'Tipo Plataforma',
      headerProps: { style: { minWidth: '200px' }, className: 'ps-5' },
      cellProps: { className: 'ps-5' }
    },
    {
      accessorKey: 'idplataforma',
      header: '',
      disableSortBy: true,
      cellProps: {
        className: 'text-end'
      },
      cell: ({ row: { original } }) => {
        const { idplataforma } = original;

        return (
          <>
            <Button
              variant="falcon-default"
              size="sm"
              title="Editar"
              onClick={() => {
                setIdTipoPlataforma(idplataforma);
                setOpenModal(true);
              }}
            >
              <FontAwesomeIcon icon="pencil-alt" />
            </Button>
            {/* <Button
                      variant="falcon-default"
                      size="sm"
                      title="Eliminar"
                      onClick={() => {
                        setIdMunicipioToDelete(idmunicipio);
                        setOpenConfirm(true);
                      }}
                    >
                      <FontAwesomeIcon icon="trash-alt" />
                    </Button> */}
          </>
        );
      }
    }
  ];
  return (
    <>
      <GenericTable
        data={tiposPlataforma}
        columns={columns}
        title="Tipos de Plataforma"
        addAction={() => {
          setIdTipoPlataforma(0);
          setOpenModal(true);
        }}
      ></GenericTable>
    </>
  );
};

TiposPlataformaTable.propTypes = {
  tiposPlataforma: PropTypes.array.isRequired,
  setIdTipoPlataforma: PropTypes.func.isRequired,
  setOpenModal: PropTypes.func.isRequired
};

export default TiposPlataformaTable;
